import { render, staticRenderFns } from "./UnregisteredVesselCreatorDialog.vue?vue&type=template&id=771ea509"
import script from "./UnregisteredVesselCreatorDialog.vue?vue&type=script&lang=ts"
export * from "./UnregisteredVesselCreatorDialog.vue?vue&type=script&lang=ts"
import style0 from "./UnregisteredVesselCreatorDialog.vue?vue&type=style&index=0&id=771ea509&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports